module.exports = __webpack_public_path__ + "static/media/paper.f413d707.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/paper.svg
// module id = 138
// module chunks = 0